import { render, staticRenderFns } from "./HomeFtthData.vue?vue&type=template&id=4de1f055&scoped=true&"
import script from "./HomeFtthData.vue?vue&type=script&lang=js&"
export * from "./HomeFtthData.vue?vue&type=script&lang=js&"
import style0 from "./HomeFtthData.vue?vue&type=style&index=0&id=4de1f055&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de1f055",
  null
  
)

export default component.exports